module.exports = __webpack_public_path__ + "img/wz-8-5-2.13505be1.jpg";